
import React, { useCallback, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { DeleteIcon } from "@chakra-ui/icons";
import { Heading, HStack, IconButton, ModalCloseButton, Textarea, VStack } from "@chakra-ui/react";
import { useRef } from "react";
import { TbBrain} from 'react-icons/tb';
import {  FaCopy, FaFileAlt, FaLightbulb, FaMagic, FaRobot, FaSync } from "react-icons/fa";
import {
  Badge,
  Box,
  Grid,
  Circle,
  GridItem,
  Divider,
  Spacer,
  Button,
  Spinner,
  Center,
  Text,
  Flex,
  useToast,
  Icon,
  Select,
  Input,
  Modal,
  ModalOverlay,
  ModalContent, 
  ModalHeader,
  ModalBody,
  Tooltip,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  FormControl,
  FormLabel,
  ModalFooter,
  CloseButton
} from "@chakra-ui/react";
import { MdAdd, MdArrowBack, MdArrowForward, MdClose, MdDelete, MdSave } from "react-icons/md";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { react_api } from "../config";
import { CASE_TYPE } from "../CaseTypeCostant";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import logout from "../services/authService";
import createAxiosInstance from "../interceptors/useAxiosInterceptors"
import { useSession } from '../SessionContext';
import {  useNavigate} from "react-router-dom";
import { useTranslation } from "react-i18next";
import AISQLGenerator from "./AISQLGenerator";


   

const getBackgroundColorByVisibility = (visibility) => {


  if (visibility === "private") {
    return "green.400";
  } else if (visibility === "obtained") {
    return "orange.400";
  } else if (visibility === "public") {
    return "yellow.400";
  }
  else if (visibility === "general") {
    return "blue.400";
  }
  else {
    return "blue.500"
  }
}




var aggregationTypes = [
  
  { label: "AVG", id: "avg" },
  { label: "SUM", id: "sum" },
  { label: "MIN", id: "min" },
  { label: "MAX", id: "max" },
  { label: "COUNT", id: "count" }
];


var catalog1 = ([] = []);



const DraggableItem = ({ id, text, visibility }) => {

  const [, drag] = useDrag(() => ({
    type: "ITEM",
    item: { id: id.sqlId || id.id  , type: id.type },
  }));


  let buttonColor = getBackgroundColorByVisibility(visibility)


  
  return (
    <Button h="20px" ref={drag} bg={buttonColor} borderWidth={1} borderColor={"black"}>
      {text}
    </Button>
  );




};
const DraggableItemCustom = ({ id, text, visibility }) => {

  const [, drag] = useDrag(() => ({
    type: "ITEM",
    item: { id: id.sqlId || id.id  , type: id.type },
  }));

  return (
    <>
      {id.type === "column" || id.type === "first" || id.type === "second" ? (
        <Button ref={drag} colorScheme="blue" borderWidth={1} borderColor={"black"}       
          h="auto"
          px={3}
          py={1}
          whiteSpace="normal"
          wordBreak="break-word">
          {text}
        </Button>
      ) : (
        <Button ref={drag}  borderWidth={1} borderColor={"black"}               
          h="auto"
          minH="50px"
          px={3}
          py={4}
          whiteSpace="normal"
          color="white"           
          fontSize="lg"           
          fontWeight="semibold"  
          bgGradient="linear(to-r, teal.400, teal)"
          _hover={{
            bgGradient: "linear(to-r, teal, teal.400)",
            transform: "scale(1.05)",
            boxShadow: "xl",
          }}
          _active={{
            bgGradient: "linear(to-r, teal.500, teal)",
            transform: "scale(0.98)",
          }}
          _focus={{
          outline: "none",
          boxShadow: "outline",
          }}
        >
          {text}
        </Button>
      )}
    </>
  );
};

  


const DroppableArea = ({  setSelectedOperationId,selectedOperationId,i18n,t, buttonsOperationSelect, buttonsOperationJoin,  onDrop, children , pageSelected,setPageSelected, colorCircle,setColorCircle, handleClickEsegui,pulisci, setDatasetView, setOperation, setColumnsDropped,columnsDropped,operation,columnsDroppedFirstUnionDataset,columnsDroppedSecondUnionDataset,aggregationView, setAggregationView, matematicalFilterView, textualFilterView   ,setTextualFilterView, setMatematicalFilterView,columnsFirstUnionDataset,setColumnsDroppedFirstUnionDataset,setColumnsDroppedSecondUnionDataset,setFirstUnionDataset,setSecondUnionDataset,handleIconClickDeSelectAllColumnsFirstDataset,handleIconClickDeSelectAllColumnsSecondDataset,setUnionKeysView,unionKeysView}) => {
  const pageSelectedRef = useRef(pageSelected);

  // Aggiorna la ref ogni volta che `pageSelected` cambia
  React.useEffect(() => {
 
    pageSelectedRef.current = pageSelected;
  }, [pageSelected]);

React.useEffect(() => { 
  if (!selectedOperationId) return;

  // Trova l'operazione usando l'ID univoco
  const currentOpJoin = buttonsOperationJoin.find(btn => btn.id === selectedOperationId);
  const currentOpSelect = buttonsOperationSelect.find(btn => btn.id === selectedOperationId);
  
  const currentOp = currentOpJoin || currentOpSelect;
  
  if (currentOp) {
    setOperation(currentOp.label); // Aggiorna con la nuova traduzione
  }
}, [i18n.language, selectedOperationId, buttonsOperationJoin, buttonsOperationSelect]);



  const [{ isOver }, drop] = useDrop(() => ({

    
    accept: "ITEM",
    drop: (item) => {
      console.log(pageSelected)
    
   
      let btnOperationJoin = buttonsOperationJoin.find(
        (btnOperationJoin) => btnOperationJoin.label == item.id
      );
      let btnOperationSelect = buttonsOperationSelect.find(
        (btnOperationSelect) => btnOperationSelect.label == item.id
      );

    

      onDrop(
        item.id,
        pageSelectedRef.current,
        btnOperationJoin != null ? btnOperationJoin : btnOperationSelect,
        item.type
      );
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
}), [onDrop, buttonsOperationJoin, buttonsOperationSelect]); 

  return (
    
   


    <GridItem

    ref={drop}
    colSpan={3}
    border="2px dashed"
    borderRadius="md"
    p={4}
    position="relative"
    d="flex"
    justifyContent="center"
    alignItems="center"
    borderColor="gray.300"
  >
    {/* Semaforo (pallino) in alto a destra */}
    <Circle
      size="30px"
      bg={colorCircle}
      position="absolute"
      top="8px"
      right="8px"
    />



<Box textAlign="center" color="gray.500" fontSize="lg">
  {(() => {
    switch (pageSelected) {
      case "selected_operation":
        return t("queryTool.droppableArea.dragOperation");
      case "selected_dataset":
        return t("queryTool.droppableArea.dragDataset");
      case "selected_attibute":
        return t("queryTool.droppableArea.selectDatasetColumns");
      case "selected_attibute_first_dataset":
        return t("queryTool.droppableArea.selectFirstDatasetColumns");
      case "selected_attibute_second_dataset":
        return t("queryTool.droppableArea.selectSecondDatasetColumns");
      case "selected_first_dataset":
      case "selected_second_dataset":
        return t("queryTool.droppableArea.dragFirstSecondDataset");
      case "add_aggregation_view":
        return t("queryTool.droppableArea.addAggregationColumns");
      case "add_filter":
        return t("queryTool.droppableArea.addTextMathFilters");
      case "add_union_key":
        return t("queryTool.droppableArea.addUnionKeys");
      default:
        return t("queryTool.droppableArea.unknownState");
    }
  })()}
</Box>


  

    {children}


    <Flex position="absolute" bottom="8px" right="8px" mt={1} gap={4}> 
    <IconButton
            colorScheme="red"
            icon={<DeleteIcon color="white" _hover={{ color: "white"}} />}
            aria-label="Pulisci"
            size="md"
            onClick={()=> pulisci()}

          />


      {pageSelected != "selected_operation" && (   
        
        
        <Button colorScheme="blue" onClick={()=> {




        
        switch(pageSelected) {
          case "selected_dataset":

            setDatasetView()
            setColorCircle("red.500")
            setOperation(null)
            setPageSelected("selected_operation")
             setSelectedOperationId(null) 
           
          

          break


          case "selected_attibute":

          
          setColorCircle("#FFA500")
          setPageSelected("selected_dataset")
          setColumnsDropped([])
          setDatasetView()
        

          break


          case "selected_operation":

          setOperation()
          setColorCircle("red.500")
        

        break

        case "add_aggregation_view":
        setColorCircle("#FFA500")
        if(aggregationView && aggregationView.length >0 ) {
        setAggregationView([]);
        }else {
        setPageSelected("selected_attibute")
        }
      
        break


        case "add_filter":
       
        setColorCircle("#FFA500")

        if(textualFilterView && textualFilterView.length >0 || matematicalFilterView && matematicalFilterView.length >0) {
       
           setTextualFilterView([]);
        setMatematicalFilterView([])
        
        }else {
         
         setPageSelected("selected_attibute")
        }
        break


        case "add_union_key":
          setColorCircle("#FFA500")

        if(unionKeysView && unionKeysView.length >0) {
        setUnionKeysView([])
        
        }else {
         setUnionKeysView([])
        setPageSelected("selected_attibute_second_dataset")
        }

      
       

        break

       case "selected_first_dataset":
   
        setFirstUnionDataset()
        setSecondUnionDataset()
        setColumnsDroppedFirstUnionDataset([])
        setColumnsDroppedSecondUnionDataset([])
        setUnionKeysView([])

        setOperation(null)
        setSelectedOperationId(null)
        setColorCircle("red.500")
        setPageSelected("selected_operation")
        break


          case "selected_attibute_first_dataset":
          
          setColorCircle("#FFA500")
         


          if(columnsDroppedFirstUnionDataset.length >0) {
            handleIconClickDeSelectAllColumnsFirstDataset()
          }else {
              setFirstUnionDataset()
              setSecondUnionDataset()
              setPageSelected("selected_first_dataset")
          }

         



          
    
    break

  
  case "selected_attibute_second_dataset":
  setColorCircle("#FFA500");
  
  
  if(columnsDroppedSecondUnionDataset && columnsDroppedSecondUnionDataset.length > 0) {
   
    setColumnsDroppedSecondUnionDataset([]);
    
   
       handleIconClickDeSelectAllColumnsSecondDataset()
    
   
  } else {
   

    setPageSelected("selected_attibute_first_dataset");

  }
  break;




          default:
            break
        }

      }}>{t("queryTool.droppableArea.back")}</Button>)}    


      {   columnsDropped &&  columnsDropped.length >0 &&

   
      
        operation !== i18n.getResourceBundle('it', 'translation').queryTool.view_multiple_columns   &&  operation !== i18n.getResourceBundle('en', 'translation').queryTool.view_multiple_columns   && pageSelected !== "selected_operation" && pageSelected !== "add_filter" && pageSelected !== "add_aggregation_view" && pageSelected !== "add_union_key" && (  
         
         <Button colorScheme="blue" onClick={()=> {


            
        


          switch(operation) {
         
            case  i18n.getResourceBundle('it', 'translation').queryTool.view_grouped_columns:
            case  i18n.getResourceBundle('en', 'translation').queryTool.view_grouped_columns:
            setPageSelected("add_aggregation_view")
            break
               
             case i18n.getResourceBundle('it', 'translation').queryTool.view_filtered_dataset:
             case i18n.getResourceBundle('en', 'translation').queryTool.view_filtered_dataset:
             setPageSelected("add_filter")
             break


            default:
              break
          }


          



      }}> {t("queryTool.droppableArea.next")}</Button>
  

       

 )}
        


{((pageSelected === "selected_attibute_first_dataset" ? 
   (columnsDroppedFirstUnionDataset && columnsDroppedFirstUnionDataset.length > 0) :
   pageSelected === "selected_attibute_second_dataset" ? 
   (columnsDroppedSecondUnionDataset && columnsDroppedSecondUnionDataset.length > 0) :
   (columnsDroppedFirstUnionDataset && columnsDroppedFirstUnionDataset.length > 0))) && 
  pageSelected !== "selected_first_dataset" && 
  pageSelected !== "selected_operation" && 
  pageSelected !== "selected_second_dataset" && 
  pageSelected !== "add_filter" && 
  pageSelected !== "add_aggregation_view" && 
  pageSelected !== "add_union_key" && (
    <Button 
      colorScheme="blue" 
      onClick={() => { 
        if(pageSelected === "selected_attibute_second_dataset") { 
          setPageSelected("add_union_key") 
        } else {
          setPageSelected("selected_attibute_second_dataset")
        }
      }}
    >
      {t("queryTool.droppableArea.next")}
    </Button> 
)}




{colorCircle == "green.500" && (
  <Button
  colorScheme="blue"
  onClick={() => {
    handleClickEsegui() ; console.log(pageSelected)
  }}
>
  {t("queryTool.droppableArea.sendQuery")}
</Button>
)}

</Flex>

  </GridItem>
  
  );
};

function DragAndDrop() {




  const [operation, setOperation] = useState();
  const [datasetView, setDatasetView] = useState();



  const [firstUnionDataset, setFirstUnionDataset] = useState();
  const [secondUnionDataset, setSecondUnionDataset] = useState();

  const [columnsDroppedFirstUnionDataset, setColumnsDroppedFirstUnionDataset] = useState([]);
  const [columnsDroppedSecondUnionDataset, setColumnsDroppedSecondUnionDataset] = useState([]);

 
  const [columnsFirstUnionDataset, setColumnsFirstUnionDataset] = useState([]);
  const [columnsSecondUnionDataset, setColumnsSecondUnionDataset] = useState([]);
 
  const [columnsFirstUnionDatasetCopy, setColumnsFirstUnionDatasetCopy] = useState([]);
  const [columnsSecondUnionDatasetCopy, setColumnsSecondUnionDatasetCopy] = useState([]);

  const [isLoadingModalAI, setIsLoadingModalAI] = useState(false);
   const [isModalResultAIOpen, setIsModalResultAIOpen] = useState(false);
  const [textAI, setTextAI] = useState(false);
  const [isSimpleSelect, setIsSimpleSelect] = useState(false);


  const [operazioniSelect, setOperazioniSelect] = useState([]);
  const [operazioniJoin, setOperazioniJoin] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnsCopy, setColumnsCopy] = useState([]);
  const [columnsDropped, setColumnsDropped] = useState([]);
  const [catalog, setCatalog] = useState([]);
  const toast = useToast();

  const [aggregationView, setAggregationView] = useState([]);
  const [matematicalFilterView, setMatematicalFilterView] = useState([]);
  const [textualFilterView, setTextualFilterView] = useState([]);
  const [unionKeysView, setUnionKeysView] = useState([]);


  const [activitySelected, setActivitySelected] = useState("");

  const [pageSelected, setPageSelected] = useState("selected_operation");
const [selectedOperationId, setSelectedOperationId] = useState();


  const [objectPagination, setObjectPagination] = useState({});

  const [generalLoading, setGeneralLoading] = useState(false);
  const [resultLoading, setResultLoading] = useState(false);

  const { t , i18n} = useTranslation();




const buttonsOperationSelect = [
  { label: t("queryTool.view_dataset"), id: "SELECT *", class: "btn-success" },
  { label: t("queryTool.view_multiple_columns"), id: "SELECT MULTICOL", class: "btn-success" },
  { label: t("queryTool.view_grouped_columns"), id: "SELECT AGGR", class: "btn-success" },
  { label: t("queryTool.view_filtered_dataset"), id: "SELECT WHERE", class: "btn-success" },
];

const buttonsOperationJoin = [
  { label: t("queryTool.union"), id: "INNER JOIN", class: "btn-success" },
  { label: t("queryTool.left_outer_join"), id: "LEFT JOIN", class: "btn-success" },
  { label: t("queryTool.right_outer_join"), id: "RIGHT JOIN", class: "btn-success" },
  { label: t("queryTool.full_outer_join"), id: "FULL JOIN", class: "btn-success" },
];
const getMatTypes = () => [
  { label: "=", id: t("queryTool.operators.equal") },
  { label: "!=", id: t("queryTool.operators.notEqual") },
  { label: ">", id: t("queryTool.operators.greater") },
  { label: "<", id: t("queryTool.operators.less") },
  { label: ">=", id: t("queryTool.operators.greaterEqual") },
  { label: "<=", id: t("queryTool.operators.lessEqual") },
];

const getTextTypes = () => [
  { label: "=", id: t("queryTool.operators.equalTo") },
  { label: "!=", id: t("queryTool.operators.differentFrom") },
];


  const [isModalResultOpen, setIsModalResultOpen] = useState(false);
  const [keysResult, setKeysResult] = useState([]);
  const [resultData, setResultData] = useState([]);
  const [payloadRequestResult, setPayloadRequestResult] = useState({});
  const [isModalSave ,setIsModalSave] = useState(false)


  const [colorCircle, setColorCircle] = useState("red.500");
  


  const pageSelectedRef = useRef(pageSelected);

  // Aggiorna la ref ogni volta che `pageSelected` cambia
  React.useEffect(() => {
    
    pageSelectedRef.current = pageSelected;
  }, [pageSelected]);

  
   const closeResulAItModal = () => {
    setIsModalResultAIOpen(false);
  
  };
  const closeResultModal = () => {
    setIsModalResultOpen(false);
  };

  const closeSaveModal = () => {
    setIsModalSave(false);
  };
  const openaResultModal = () => {
    setIsModalSave(true)
    
  };
  const getCOUNT = () => {

   

    removeCountFromAggregationTypes();

    return <Box  display="flex"             // Imposta il display a flex
  alignItems="center"       // Allinea verticalmente al centro
  justifyContent="center"    // Allinea orizzontalmente al centro
              // Imposta l'altezza del box (puoi modificare questo valore)
    >
    
  {"COUNT"}</Box>
    
  };

  


  const [query, setQuery] = useState('');

  const salvaRisultato = async (tableName) => {
    try {
      const richiesta = {
        username: sessionStorage.getItem('username'),
        query: query,
        tableName: tableName
      }

      const options = {
        "Content-Type": "application/json",
        'Authorization' : sessionStorage.getItem('token')
      }

        const urlFetch = `${react_api}/DragAndDrop/saveDatasetADP`;
        const response = await axiosInstance.post(urlFetch,richiesta, options);
        const result = response.data;
        if (result.status === HTTP_STATUS_CODES.OK) {
          toast({
            title: "Chiamata andata a buon fine",
            description: "",
            position: "top",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          closeSaveModal();
        }
          
    }
    catch (error) {
      toast({
        title: "Chiamata in errore",
        description: String(error),
        position: "top",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
    }
  }

  const backResult = () => {
    // Update the state and then run the request
    setPayloadRequestResult(prevState => {
      const newState = {
        ...prevState,
        window: prevState.window - 1
      };
      setResultLoading(true)


      if(payloadRequestResult.isAiSqlGenerated) {
        executeSQLAIGenerated(axiosInstance,newState.query,newState.window,toast).then(res => {
       
        if (res != null  && res.data && res.data.data != null && res.data.data.length > 0) {
          let objPagination = res.data.data.find(item => item.hasOwnProperty('max_window_num'))
          setObjectPagination(objPagination)
          const dataWithRowNumbers = addRowNumbers(res.data.data, objPagination.offset);
          setResultData(dataWithRowNumbers);
          setResultLoading(false)

        }
      });
      }else {

        runRequest(newState).then(res => {
       
        if (res != null && res.data != null && res.data.length > 0) {
          let objPagination = res.data.find(item => item.hasOwnProperty('max_window_num'))
          setObjectPagination(objPagination)
          const dataWithRowNumbers = addRowNumbers(res.data, objPagination.offset);
          setResultData(dataWithRowNumbers);
          setResultLoading(false)

        }
      });
      }

      // Run the request with the new state
      
  
      // Log the new state
    
  
      return newState; // Return the new state
    });
  };
  
  const nextResult = () => {
    // Update the state and then run the request
      setPayloadRequestResult(prevState => {
      const newState = {
        ...prevState,
        window: prevState.window + 1
      };

      
      

        setResultLoading(true)
      // Run the request with the new state
         if(payloadRequestResult.isAiSqlGenerated) {
          
         executeSQLAIGenerated(axiosInstance,newState.query,newState.window,toast).then(res => {
          console.log(res)
        if (res != null && res.data &&  res.data.data != null && res.data.data.length > 0) {
          let objPagination = res.data.data.find(item => item.hasOwnProperty('max_window_num'))
          setObjectPagination(objPagination)
          const dataWithRowNumbers = addRowNumbers(res.data.data, objPagination.offset);
          delete dataWithRowNumbers[dataWithRowNumbers.length -1]
          setResultData(dataWithRowNumbers);
          setResultLoading(false)
        

        }
      });
      }else {
      runRequest(newState).then(res => {
        if (res != null && res.data != null && res.data.length > 0) {
          // Calcola il numero di righe attuale per il numero di partenza
          let objPagination = res.data.find(item => item.hasOwnProperty('max_window_num'))
          setObjectPagination(objPagination)
          const dataWithRowNumbers = addRowNumbers(res.data, objPagination.offset);
          delete dataWithRowNumbers[dataWithRowNumbers.length -1]
          setResultData(dataWithRowNumbers);
          setResultLoading(false)
          
        }
      });
      }
  
      // Log the new state
      
  
      return newState; // Return the new state
    });
  };


  const { updateSessionData, clearSessionData} = useSession();
  const navigate = useNavigate();
  const axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(clearSessionData,navigate,toast,axiosInstance)
  });


  useEffect(() => {


    
    
  
    fetchCatalog();
  }, [toast]);

 
 
  const handleIconClickOperazioni = () => {


    setColumns([])
    setColumnsCopy([])

    setColumnsDropped([])

    setColumnsFirstUnionDataset([])
    setColumnsSecondUnionDataset([])

    setDatasetView()

   


    
  
    if (buttonsOperationJoin.map((btn) => btn.label).includes(operation)) {
      
      if(activitySelected != "Visualizza" ){
      
     
      setColumnsDropped([])  
      setOperazioniJoin(buttonsOperationJoin);
      }
    }
    if (buttonsOperationSelect.map((btn) => btn.label).includes(operation)) {
      
      if(activitySelected == "Visualizza") {

      setFirstUnionDataset()
      setSecondUnionDataset()
      setColumnsDroppedFirstUnionDataset([])
      setColumnsDroppedSecondUnionDataset([])  
      setOperazioniSelect(buttonsOperationSelect);
      reInitializaAggregationTypes();
      
      }

    }

   
    setOperation();
    setColorCircle("red.500")
  };

  const handleIconClickDataset = (droppableAreaId) => {
  
    switch(droppableAreaId) {
      case "selected_dataset":
        setDatasetView();
        setColumns([])
        setColumnsDropped([])
        reInitializaAggregationTypes();
      
        break

        case "selected_first_dataset":
          setFirstUnionDataset()
          setColumnsFirstUnionDataset([])
          setColumnsFirstUnionDatasetCopy([])
          setColumnsDroppedFirstUnionDataset([])
          break

          case "selected_second_dataset":
            setSecondUnionDataset()
            setColumnsSecondUnionDataset([])
            setColumnsSecondUnionDatasetCopy([])
            setColumnsDroppedSecondUnionDataset([])
            break

            default:
              break;

    }
    
    
   
    
    
  };


  
  const handleIconClickColumnsFirstUnionDataset = (item) => {
    setColumnsDroppedFirstUnionDataset((prevColumnsFirstUnionDatasetDropped) =>
      prevColumnsFirstUnionDatasetDropped.filter((column) => column !== item)
    );

    setColumnsFirstUnionDataset((prevColumns) => [item, ...prevColumns]);
  };

  const handleIconClickColumnsSecondUnionDataset = (item) => {
    setColumnsDroppedSecondUnionDataset((prevColumnsSecondUnionDatasetDropped) =>
      prevColumnsSecondUnionDatasetDropped.filter((column) => column !== item)
    );

    setColumnsSecondUnionDataset((prevColumns) => [item, ...prevColumns]);
  };

  const handleIconClickColumns = (item) => {
    

   
    setColumnsDropped((prevColumnsDropped) => {
      
     let columnsDroppedFiltered =   prevColumnsDropped.filter((column) => column !== item)
     matematicalFilterView.filter(matFilter => matFilter.attribute === item).forEach(matFilter => {
     
      setMatematicalFilterView((matematicalFilterView) =>
        matematicalFilterView.map((filter) => 
          filter.id === matFilter.id 
            ? { ...filter, attribute: columnsDroppedFiltered[0] }  // Modifica solo il campo "attribute"
            : filter
        )
      );
    })

    textualFilterView.filter(textFilter => textFilter.attribute === item).forEach(textFilter => {
      setTextualFilterView((textualFilterView) =>
        textualFilterView.map((filter) => 
          filter.id === textFilter.id 
            ? { ...filter, attribute: columnsDroppedFiltered[0] }  // Modifica solo il campo "attribute"
            : filter
        )
      );
    })



     return columnsDroppedFiltered;
      
    }
    );

    
    setColumns((prevColumns) => [item, ...prevColumns]);

    reInitializaAggregationTypes();
    

    setColumnsDropped(prevColumnsDropped => {

      if(prevColumnsDropped.length ===0){
        setColorCircle("#FFA500")
      }

      return prevColumnsDropped
    })

   
    }

    



    

  

  const handleIconClickSelectAllColumns = () => {

      setColumnsDropped(columnsCopy);
      setColumns([]);
      if(operation ===  i18n.getResourceBundle('it', 'translation').queryTool.view_multiple_columns  || operation ===  i18n.getResourceBundle('en', 'translation').queryTool.view_multiple_columns   )
      setColorCircle("green.500")

  };

  const handleIconClickSelectAllColumnsFirstDataset = () => {

    setColumnsDroppedFirstUnionDataset(columnsFirstUnionDatasetCopy)
    
    setColumnsFirstUnionDataset([]);
  };



  const handleIconClickSelectAllColumnsSecondDataset = () => {

  
      setColumnsDroppedSecondUnionDataset(columnsSecondUnionDatasetCopy)
    
    
      setColumnsSecondUnionDataset([]);


      
  };


  const handleIconClickDeSelectAllColumns = () => {
    setColumnsDropped([]);
    setColumns(columnsCopy);
    reInitializaAggregationTypes();
    setColorCircle("#FFA500")
    
  };


const handleIconClickDeSelectAllColumnsFirstDataset = () => {
 
  setColumnsDroppedFirstUnionDataset([]);
  

  setColumnsFirstUnionDataset([]);

  

  if (firstUnionDataset) {
    setColumnsFirstUnionByTableName(firstUnionDataset);
  }

  setPageSelected("selected_attibute_first_dataset");
};



const handleIconClickDeSelectAllColumnsSecondDataset = () => {
  
  setColumnsDroppedSecondUnionDataset([]);
  
  
  setColumnsSecondUnionDataset([]);

  
  
  if (secondUnionDataset) {
    setColumnsSecondUnionByTableName(secondUnionDataset);
  }

  setPageSelected("selected_attibute_second_dataset");
};

  const addAggregationView = (id) => {
   
    
    if(columnsCopy.length === columnsDropped.length) {
      if(!aggregationView.find(aggregationView => aggregationView.operation === "COUNT")) { 
        setAggregationView((aggregation) => [...aggregation, {id: id.toString(), attribute:"*",operation:"COUNT", columnAlias: null}]);
      }

      
      
    }else {
      setAggregationView((aggregation) => [...aggregation, {id: id.toString(), attribute:columns[0],operation:aggregationTypes[0].label, columnAlias: null}]);
        
    }

    

    removeCountFromAggregationTypes();
    

   

    
  };

  const removeCountFromAggregationTypes  =() => {
    if(aggregationView.find(aggregationView => aggregationView.operation === "COUNT")) {
      
      aggregationTypes = aggregationTypes.filter(aggregationTypes => aggregationTypes.label != "COUNT")
  }
  }
 
const removeAggregationView = (aggregationViewFilter) => {
  setAggregationView((aggregationViews) => {
    const filteredViews = aggregationViews.filter((aggregationView) =>  
      aggregationView.id !== aggregationViewFilter.id
    );
    
    // Se dopo il filtro la lista è vuota, imposta il colore orange
    if(filteredViews.length === 0) {
      setColorCircle("#FFA500");
    }
    
    return filteredViews;
  });
  
  if(aggregationViewFilter.operation === "COUNT") {
    aggregationTypes.push({ label: "COUNT", id: "count" });
  }        
};
  const addMatematicFilterView = (id) => {
   
    setMatematicalFilterView((matematicalFilterView) => [
      ...matematicalFilterView,

     
      {id: id, operation: t("queryTool.operators.equal") ,attribute:columnsDropped[0], userInput: null },
    ]);
      setColorCircle("green.500")
  };

  const removeMatematicFilterView = (matematicalFilter) => {
    setMatematicalFilterView((matematicalFilterViews) =>

    {

      const filteredMathematicalView = matematicalFilterViews.filter(
      (matematicalFilterView) => matematicalFilterView.id !== matematicalFilter.id);
    
      // Se dopo il filtro la lista è vuota, imposta il colore orange
      if(filteredMathematicalView.length === 0 && textualFilterView.length === 0) {
        setColorCircle("#FFA500");
      }
    
        return filteredMathematicalView;
      });
  };

  const addTextualFilterView = (id) => {

    
    setTextualFilterView((textualFilterView) => [...textualFilterView, {id: id, operation:t("queryTool.operators.equalTo"),attribute:columnsDropped[0], userInput: null }]);
      setColorCircle("green.500")
  };

  const removeTextualFilterView = (textualFilter) => {
    setTextualFilterView((textualFilterViews) =>

       {

      const filteredTextualView = textualFilterViews.filter((textualFilterView) => textualFilterView.id !== textualFilter.id);
    
      // Se dopo il filtro la lista è vuota, imposta il colore orange
      if(filteredTextualView.length === 0 && matematicalFilterView.length === 0) {
        setColorCircle("#FFA500");
      }
    
        return filteredTextualView;
      }
      
      
    );
  };


  const addUnionKeysView = (id) => {
    
    setUnionKeysView((textualFilterView) => [...textualFilterView, {id: id, colonnaSelezionataPrimoDataset:columnsFirstUnionDatasetCopy[0],colonnaSelezionataSecondoDataset:columnsSecondUnionDatasetCopy[0]}]);
      setColorCircle("green.500")

  };

  const removeUnionKeysView = (unionKeysFilter) => {

    
    setUnionKeysView((unionKeysViews) =>

       {

      const filteredUnionKeyView = unionKeysViews.filter((unionKeysView) => unionKeysView.id !== unionKeysFilter.id);
    
      // Se dopo il filtro la lista è vuota, imposta il colore orange
      if(filteredUnionKeyView.length === 0 ) {
        setColorCircle("#FFA500");
      }
    
        return filteredUnionKeyView;
      }
      
    );
  };

  const updateUnionKeysView = (id, val,identifier) => {
    
    setUnionKeysView((unionKeysView) =>
      unionKeysView.map((item) =>  {
       

        if(item.id == id) {
          identifier == t("queryTool.column_first_dataset") ? item.colonnaSelezionataPrimoDataset = val :  item.colonnaSelezionataSecondoDataset= val
          return item;
        }
        return item;
      
      })
        
    );
  };


  const updateMatematicalFilterView = (id, val,identifier) => {

    
    setMatematicalFilterView((matematicalFilterView) =>
      matematicalFilterView.map((item) =>  {
       

        if(item.id == id) {
          
          item[identifier] = val

          return item;
        }
        return item;
      
      })
        
    );
  };


  const updateTextualFilterView = (id, val,identifier) => {
    
    setTextualFilterView((textualFilterView) =>
      textualFilterView.map((item) =>  {
       

        if(item.id == id) {
          
          item[identifier] = val

          return item;
        }
        return item;
      
      })
        
    );
  };

  
const updateAggregationView = (id, val, identifier) => {
  setAggregationView((prevAggregationView) => {
    const updatedView = prevAggregationView.map((item) => {
      if(item.id === id) {
        return { ...item, [identifier]: val }; // meglio creare un nuovo oggetto
      }
      return item;
    });
    
    // Controllo dopo l'aggiornamento
    if(updatedView.every(agView => agView.columnAlias != null && agView.columnAlias !== "")) {
      setColorCircle("green.500");
    } else {
       setColorCircle("#FFA500");
    }
    
    return updatedView;
  });
};

  const [resultName, setResultName] = useState('')
  const handleChangeResultName = (val) =>{
    setResultName(val)
  }
  
  const handleChangeUnionKeysView = (val, id, identifier) => {
    

      updateUnionKeysView(id.id ,val, identifier)

     


  };

  const handleChangeMatematicalFilterView = (val, id, identifier) => {

    updateMatematicalFilterView(id.id ,val, identifier)

 


};


const handleChangeTextualFilterView = (val, id, identifier) => {

  

  updateTextualFilterView(id.id ,val, identifier)

  


};


const handleChangeAggregationView = (val, id, identifier) => {

 setColorCircle("#FFA500");

 updateAggregationView(id.id ,val, identifier)


};






const handleClickEseguiAISQLGenerator = (res) => {



   
    setGeneralLoading(false)


    
    
    if(res != null &&  res.data != null && res.data.length >1) {
      let objPagination = res.data.find(item => item.hasOwnProperty('max_window_num'))
         console.log(objPagination)

      if(objPagination && objPagination.max_window_num) {
        setObjectPagination(objPagination)

  
      } 

      const dataWithRowNumbers = addRowNumbers(res.data,objPagination.offset);

      setKeysResult(Object.keys(dataWithRowNumbers[0]));

      // Imposta i dati con i numeri di riga
      setResultData(dataWithRowNumbers);
      
      setIsModalResultOpen(true)
    }else if(res !=null && res.data != null && res.data.length === 1) {


      

      toast({
        title: 'Non vi sono dati da mostrare',
        description: "",
        position: "top",
        status: 'info',
        duration: 4000,
        isClosable: true
      });

      
    }
    
   
   
  
}

const handleClickEsegui = () => {
  setGeneralLoading(true)
 runRequest(null).then(res => {

  


    
    setGeneralLoading(false)
    if(res != null &&  res.data != null && res.data.length >1) {
      let objPagination = res.data.find(item => item.hasOwnProperty('max_window_num'))

      if(objPagination && objPagination.max_window_num) {
        setObjectPagination(objPagination)

  
      } 

      const dataWithRowNumbers = addRowNumbers(res.data,objPagination.offset);

      setKeysResult(Object.keys(dataWithRowNumbers[0]));

      // Imposta i dati con i numeri di riga
      setResultData(dataWithRowNumbers);
      
      setIsModalResultOpen(true)
    }else if(res !=null && res.data != null && res.data.length === 1) {


      

      toast({
        title: 'Non vi sono dati da mostrare',
        description: "",
        position: "top",
        status: 'info',
        duration: 4000,
        isClosable: true
      });

      
    }
    
   
   
  })
};

const addRowNumbers = (data, startNumber) => {
  return data.filter(data => !data.hasOwnProperty("max_window_num")).map((item, index) => ({
    "Numero Riga": startNumber + index, // Aggiunge il numero di riga partendo da `startNumber`
    ...item
  }));
};



 async function text2queryResponse(sqlQuery, plainText) {
   const url = `${react_api}/privateService/text2query`;
    
    try {
        // Creazione di FormData per @RequestPart
        const formData = new FormData();
        formData.append('sqlQuery', sqlQuery);
        formData.append('plainText', plainText);

        const response = await axiosInstance.post(url, formData, {
            headers: {
                // Non impostare Content-Type, lascia che il browser lo gestisca automaticamente
                // per multipart/form-data con boundary corretto
            },
            // Abilita i cookie per allowCredentials = "true"
            withCredentials: true
        });
        
        return response.data;
    } catch (error) {
        console.error('Errore nella chiamata API:', error);
        throw error;
    }
  }
      


const executeSQLAIGenerated = async (axiosInstance,sqlQuery, window,toast) => {
  try {
    if (!sqlQuery || sqlQuery.trim() === "" || sqlQuery === "Sorry, this is not a valid text to convert in sql. I do not know how to respond") {
      toast({
        title: 'Query vuota',
        description: 'Inserisci una query SQL valida per l\'esecuzione',
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
      return null;
    }

    // Recupera l'username dal sessionStorage
    const username = sessionStorage.getItem("username");
    if (!username) {
      toast({
        title: 'Errore di autenticazione',
        description: 'Username non trovato. Effettua il login.',
        position: "top",
        status: 'error',
        duration: 4000,
        isClosable: true
      });
      return null;
    }

    // Pulisci la query SQL rimuovendo i backticks del markdown
const cleanedQuery = sqlQuery
  .replace(/^```sql\s*/i, '')    // Rimuove ```sql all'inizio
  .replace(/^```\s*/, '')        // Rimuove ``` all'inizio  
  .replace(/\s*```$/g, '')       // Rimuove ``` alla fine
  .replace(/\n```\s*$/g, '')     // Rimuove \n``` alla fine
  .replace(/\\n```\s*$/g, '')    // Rimuove literal \n``` alla fine
  .replace(/;+\s*$/g, '')        // Rimuove punto e virgola alla fine
  .replace(/\n/g, ' ')           // Sostituisce tutti i \n con spazi
  .trim(); 
    if (!cleanedQuery) {
      toast({
        title: 'Query non valida',
        description: 'La query SQL risulta vuota dopo la pulizia.',
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
      return null;
    }

    // Chiamata HTTP al backend con Axios
    const response = await axiosInstance.post('/DragAndDrop/runAiRequestADP', {
      username: username,
      query: cleanedQuery + " ",
      window: window == null ? 1: window
    }, {
      headers: {
        'Content-Type': 'application/json',
        // Aggiungi qui l'header di autorizzazione se necessario
        // 'Authorization': `Bearer ${token}`
      },
      withCredentials: true, // Per includere i cookies se necessario
      timeout: 30000 // Timeout di 30 secondi
    });

    const result = response.data;

    setPayloadRequestResult({
      username: username,
      query: cleanedQuery + " ",
      isAiSqlGenerated: true,
      window: window == null ? 1: window
    })
    
    toast({
      title: 'Query eseguita con successo!',
      description: 'Query completata con risultati dal server.',
      position: "top",
      status: 'success',
      duration: 4000,
      isClosable: true
    });

    return { 
      success: true, 
      data: result,
      status: response.status,
      headers: response.headers
    };

  } catch (error) {
    console.error('Errore esecuzione SQL:', error);
    
    let errorMessage = 'Si è verificato un errore durante l\'esecuzione della query.';
    
    if (error.code === 'ECONNABORTED') {
      errorMessage = 'Timeout della richiesta. Il server ha impiegato troppo tempo a rispondere.';
    } else if (error.response) {
      // Il server ha risposto con un codice di errore
      errorMessage = `Errore del server (${error.response.status}): ${error.response.data || error.response.statusText}`;
    } else if (error.request) {
      // La richiesta è stata fatta ma non c'è stata risposta
      errorMessage = 'Errore di connessione al server. Verifica la connessione.';
    } else {
      // Qualcos'altro ha causato l'errore
      errorMessage = error.message || 'Errore sconosciuto.';
    }

    toast({
      title: 'Errore di esecuzione',
      description: errorMessage,
      position: "top",
      status: 'error',
      duration: 3500,
      isClosable: true
    });
    
    return null;
  }
};  
const runRequest = async (payloadRequestResult) => {
  try {
    let options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    }

    if(operation == null || operation == "") 
      return
    
    if(payloadRequestResult == null) {
      
      let operationSelect = buttonsOperationSelect.find(btnOperationSelect => btnOperationSelect.label === operation);
      let operationJoin = buttonsOperationJoin.find(btnOperationJoin => btnOperationJoin.label === operation);
  
      const richiesta = {
        operation: operationSelect == null ? operationJoin.id : operationSelect.id,
        dataset: [datasetView],
        attribute: [],
        options: [],
        window: 1
      };
  
      switch (operation) {



        case i18n.getResourceBundle('it', 'translation').queryTool.view_dataset: 
        case i18n.getResourceBundle('en', 'translation').queryTool.view_dataset:
          richiesta.attribute = [];
          richiesta.options = [];

          if(datasetView == null || datasetView == "") 
            return

          break;

        case i18n.getResourceBundle('it', 'translation').queryTool.view_multiple_columns:
        case i18n.getResourceBundle('en', 'translation').queryTool.view_multiple_columns:  
     
          richiesta.attribute = columnsDropped;
          richiesta.options = [];

          if(datasetView == null || datasetView == "" || columnsDropped== null || columnsDropped.length ===0) 
            return

          break;
        case i18n.getResourceBundle('it', 'translation').queryTool.view_filtered_dataset:  
        case i18n.getResourceBundle('en', 'translation').queryTool.view_filtered_dataset:  
          richiesta.attribute = columnsDropped;


          matematicalFilterView.forEach(filter => {
            let operatorMatType = getMatTypes().find(matType => matType.id === filter.operation);
            richiesta.options.push({
              operation:  operatorMatType.label,
              attribute: filter.attribute,
              userInput: filter.userInput
            })
           
          })

          
          textualFilterView.forEach(filter => {

            
            let operatorTextType = getTextTypes().find(textType => textType.id === filter.operation);
            richiesta.options.push({
              operation:  operatorTextType.label,
              attribute: filter.attribute,
              userInput: filter.userInput
            })
           
          })

         
          if(datasetView == null || datasetView == "" || columnsDropped== null || columnsDropped.length ===0) 
            return



          if(richiesta.options == null || richiesta.options.length === 0 || richiesta.options.some(item => item.userInput == null || item.userInput == "")) {
            return
          }

          break;

           case i18n.getResourceBundle('it', 'translation').queryTool.view_grouped_columns:  
           case i18n.getResourceBundle('en', 'translation').queryTool.view_grouped_columns:  
        
          richiesta.attribute = columnsDropped;
          richiesta.options = aggregationView.map(filter => {

            if(filter.operation === "COUNT") {
              return {
                operation: filter.operation,
                attribute: "*",
                userInput: filter.columnAlias
              };
            }

            return {
              operation: filter.operation,
              attribute: filter.attribute,
              userInput: filter.columnAlias
            };
          });


          if(datasetView == null || datasetView == "" || columnsDropped== null || columnsDropped.length ===0) 
            return

          if(richiesta.options == null || richiesta.options.length === 0 || richiesta.options.some(item => item.userInput == null || item.userInput == "")) {
            return
          }
          

          break;
        
           case i18n.getResourceBundle('it', 'translation').queryTool.union:  
           case i18n.getResourceBundle('en', 'translation').queryTool.union:  
           case i18n.getResourceBundle('it', 'translation').queryTool.left_outer_join:  
           case i18n.getResourceBundle('en', 'translation').queryTool.left_outer_join:  
           case i18n.getResourceBundle('it', 'translation').queryTool.right_outer_join:  
           case i18n.getResourceBundle('en', 'translation').queryTool.right_outer_join:  
           case i18n.getResourceBundle('it', 'translation').queryTool.full_outer_join:  
           case i18n.getResourceBundle('en', 'translation').queryTool.full_outer_join:  
       
          richiesta.dataset = [firstUnionDataset, secondUnionDataset]
         

          columnsDroppedFirstUnionDataset.forEach(columnsDroppedFirstUnionDataset => {
            richiesta.attribute.push(`${firstUnionDataset}.${columnsDroppedFirstUnionDataset}`)
          })

          columnsDroppedSecondUnionDataset.forEach(columnsDroppedSecondUnionDataset => {
            richiesta.attribute.push(`${secondUnionDataset}.${columnsDroppedSecondUnionDataset}`)
          })
         

        
          richiesta.options = unionKeysView.map(unionKeyView => {
            return {
              leftKey: unionKeyView.colonnaSelezionataPrimoDataset,
              rightKey: unionKeyView.colonnaSelezionataSecondoDataset
            };
          });


          if(firstUnionDataset == null || firstUnionDataset == "" || 
            secondUnionDataset == null || secondUnionDataset == "" || 
            columnsDroppedFirstUnionDataset== null || columnsDroppedFirstUnionDataset.length ===0 ||
            columnsDroppedSecondUnionDataset== null || columnsDroppedSecondUnionDataset.length ===0 || unionKeysView.length === 0
          ) 
            return


          break;
        default:
          return null; // Explicitly return null for unhandled operations
      }
  
      
        options.body= richiesta
        setPayloadRequestResult(richiesta);
    }else {
      options.body= payloadRequestResult
    }
    let body = options.body
    delete  options['body'];



    body.username = sessionStorage.getItem("username")
    const urlFetch = `${react_api}/DragAndDrop/runRequestADP`;
    const response = await axiosInstance.post(urlFetch, body,options);
   
    
    // Check if the response is OK and return the parsed JSON
    if (response.status.toString() === HTTP_STATUS_CODES.OK) { // response.ok is a shorthand for checking status 200-299
      const result = response.data;
     
      setQuery(result.query);
      return  response.data; // Await the JSON to get the actual data
    } else {
      return null; // Return null for non-OK responses
    }
  } catch (error) {
    
    toast({
      title: 'Chiamata in errore',
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true
    });
    return null; // Return null in case of an error
  }
};


  const handleDrop = useCallback((itemId, targetId, object, type) => {
   



    


    setTextualFilterView([])
    setMatematicalFilterView([])
    setAggregationView([])
    setUnionKeysView([])


    switch(targetId) {
      case "selected_operation":
      if (operation != null) {
        return;
      }

      // Cerca per ID SQL univoco invece che per label tradotta
      let btnOperationJoin = buttonsOperationJoin.find(
        (btn) => btn.id === itemId  // itemId ora è l'ID SQL
      );
      let btnOperationSelect = buttonsOperationSelect.find(
        (btn) => btn.id === itemId  // itemId ora è l'ID SQL
      );

      const selectedButton = btnOperationJoin || btnOperationSelect;
      
      if (!selectedButton) {
        return; 
      }
      

      setOperation(selectedButton.label);
      setSelectedOperationId(selectedButton.id); 

      // Rimuovi dalle liste usando l'ID
      if (btnOperationSelect) {
        setOperazioniSelect(
          buttonsOperationSelect.filter(
            (operazioneSelect) => operazioneSelect.id !== selectedButton.id
          )
        );
      }

      if (btnOperationJoin) {
        setOperazioniJoin(
          buttonsOperationJoin.filter(
            (operazioneJoin) => operazioneJoin.id !== selectedButton.id
          )
        );
      }

      // Determina la prossima pagina basandoti sull'ID SQL
      if(btnOperationJoin) {
        setPageSelected("selected_first_dataset");
      } else {
        setPageSelected("selected_dataset");
      }
      
      setColorCircle("#FFA500");

      break;

      case "selected_dataset":

      if(type !== "dataset") {
        return
      }

      setColumnsDropped([]);
      setColumns([])
      setColumnsCopy([])
      if (object != null) {
        return;
      }
      setDatasetView(itemId);


      setColumnsByTableName(itemId)


   


      setOperation((prevOperation) => {
        

       
        if(prevOperation !=  i18n.getResourceBundle('it', 'translation').queryTool.view_dataset && prevOperation !==  i18n.getResourceBundle('en', 'translation').queryTool.view_dataset) {
          setPageSelected("selected_attibute")
  
        }
        else  {

            setColorCircle("green.500")
        }

        return prevOperation; // Se necessario, aggiorna lo stato
      });

        break;

        case "selected_attibute":

          if(type !== "column") {
            return
          }

          if (object != null) {
            return;
          }
    
          setColumnsDropped((prevColumnsDropped) => [
            ...prevColumnsDropped,
            itemId,
          ]);
    
          setColumns((prevColumns) =>
            prevColumns.filter((column) => column !== itemId)
          );

        
        
          setOperation(prevOp => {


            setColumnsDropped(prevColumnsDropped => {
              if( (prevOp === i18n.getResourceBundle('it', 'translation').queryTool.view_multiple_columns  || prevOp === i18n.getResourceBundle('en', 'translation').queryTool.view_multiple_columns)  &&prevColumnsDropped.length >0 )  {
                setColorCircle("green.500")  
              }
              return prevColumnsDropped
            })

            

          
              
            return prevOp
          })

      

        break
          
        case "selected_first_dataset":

        if(!catalog1.map(cat => cat.table_name).includes(itemId)) {
            return
        }
        if(secondUnionDataset === itemId) {
          return
        }



        
        setColumnsDropped([])
        setColumnsFirstUnionDataset([])
        setColumnsFirstUnionDatasetCopy([])
        setColumnsSecondUnionDataset([])
        setColumnsSecondUnionDatasetCopy([])
        
        setColumnsDroppedFirstUnionDataset([])
        setColumnsDroppedSecondUnionDataset([])

        if (object != null) {
          return;
        }
        setFirstUnionDataset(itemId);
        
        setColumnsFirstUnionByTableName(itemId)

  
       
        setPageSelected("selected_second_dataset")

        break

        case "selected_second_dataset":

        if(!catalog1.map(cat => cat.table_name).includes(itemId)) {
          return
        }
       
        if(firstUnionDataset === itemId) {
          return
        }

        setColumnsSecondUnionDataset([])
        setColumnsSecondUnionDatasetCopy([])
        setColumnsDroppedSecondUnionDataset([])

        if (object != null) {
          return;
        }
        setSecondUnionDataset(itemId);
  
        setColumnsSecondUnionByTableName(itemId)


        setPageSelected("selected_attibute_first_dataset")


        break


        case "selected_attibute_first_dataset":

          

          if(type == null || type === "second") {
            return
          }

          if(catalog1.find(cat => cat.table_name === itemId)) {
            return
          }

          



          setColumnsDroppedFirstUnionDataset((prevColumnsDropped) => [
            ...prevColumnsDropped,
            itemId,
          ]);
    
          setColumnsFirstUnionDataset((prevColumns) =>
            prevColumns.filter((column) => column !== itemId)
          );

          
       
         
          
        break


        case "selected_attibute_second_dataset":

        if(type == null || type === "first") {
          return
        }
       
          
        if(catalog1.find(cat => cat.table_name === itemId)) {
          return
        }



          
      
    
          setColumnsDroppedSecondUnionDataset((prevColumnsDropped) => [
            ...prevColumnsDropped,
            itemId,
          ]);
    
          setColumnsSecondUnionDataset((prevColumns) =>
            prevColumns.filter((column) => column !== itemId)
          );


         
        break

       default:
        break 

    }


    
 }, [operation, buttonsOperationSelect, buttonsOperationJoin, i18n]);

  const setColumnsByTableName =(tableName) => {
    catalog1
    .filter((tableInfo) => tableInfo.table_name == tableName)
    .forEach((tableInfo) => {
      
      fetchColumns(tableInfo.table_id).then((columnRes) => {
        let columnNames = columnRes.tableInfo.map(
          (tableInfo) => tableInfo.columnName
        );

        

        setColumns((prevColumns) => [...prevColumns, ...columnNames]);

        setColumnsCopy((prevColumns) => [...prevColumns, ...columnNames]);

       
      });
    });
  }


const setColumnsFirstUnionByTableName = (tableName) => {
  catalog1
    .filter((tableInfo) => tableInfo.table_name === tableName)
    .forEach((tableInfo) => {
      fetchColumns(tableInfo.table_id).then((columnRes) => {
        let columnNames = columnRes.tableInfo.map(
          (tableInfo) => tableInfo.columnName
        );

      
        setColumnsFirstUnionDataset(columnNames); // Rimuovi ...prevColumns
        setColumnsFirstUnionDatasetCopy(columnNames); // Rimuovi ...prevColumns
      });
    });
};

const setColumnsSecondUnionByTableName = (tableName) => {
  catalog1
    .filter((tableInfo) => tableInfo.table_name === tableName)
    .forEach((tableInfo) => {
      fetchColumns(tableInfo.table_id).then((columnRes) => {
        let columnNames = columnRes.tableInfo.map(
          (tableInfo) => tableInfo.columnName
        );

       
        setColumnsSecondUnionDataset(columnNames); // Rimuovi ...prevColumns
        setColumnsSecondUnionDatasetCopy(columnNames); // Rimuovi ...prevColumns
      });
    });
};

   const fetchColumns = async (tableId) => {
    try {
    
    
      const urlFetch = `${react_api}/DragAndDrop/getDatasetColADP/${tableId}`;
      const response = await axiosInstance.get(urlFetch);
      const result =  response.data;
      return result;
      
    } catch (error) {
      toast({
        title: "Chiamata in errore",
        description: String(error),
        position: "top",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
    }
  };


  const fetchCatalog = async () => {
      try {
        const richiesta = {
          BearerToken: sessionStorage.getItem("token"),
          username: sessionStorage.getItem("username"),
          caseType: CASE_TYPE.CATALOG_ALL,
        };
        const options = {
       
          headers: {
            "Content-Type": "application/json",
          }
        };
        const urlFetch = `${react_api}/DragAndDrop/getDatasetsADP`;
        const response = await axiosInstance.post(urlFetch,richiesta, options);
        const result = response.data;
        if (result.status === HTTP_STATUS_CODES.OK) {



          setCatalog(result.tables_info);
          catalog1 = result.tables_info;

          return catalog1
        }


         
        } catch (error) {
        toast({
          title: "Chiamata in errore",
          description: String(error),
          position: "top",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
      }
    };


  const reInitializaAggregationTypes = () => { 
     aggregationTypes = [
  
    { label: "AVG", id: "avg" },
    { label: "SUM", id: "sum" },
    { label: "MIN", id: "min" },
    { label: "MAX", id: "max" },
    { label: "COUNT", id: "count" }
  ];

}
 const pulisci = useCallback(() => {
  setActivitySelected("");
  setAggregationView([]);
  setColumns([]);
  setColumnsByTableName();
  setColumnsCopy([]);
  setColumnsDropped([]);
  setColumnsDroppedFirstUnionDataset([]);
  setColumnsDroppedSecondUnionDataset([]);
  setColumnsFirstUnionByTableName([]);
  setColumnsFirstUnionDataset([]);
  setColumnsFirstUnionDatasetCopy([]);
  setColumnsSecondUnionByTableName([]);
  setColumnsSecondUnionDataset([]);
  setColumnsSecondUnionDatasetCopy([]);
  setDatasetView();
  setFirstUnionDataset();
  setKeysResult([]);
  setMatematicalFilterView([]);
  setObjectPagination({});
  setOperation();
  setSelectedOperationId(); // NUOVO: reset anche questo
  setOperazioniJoin([]);
  setOperazioniSelect([]);
  setPayloadRequestResult({});
  setResultData([]);
  setSecondUnionDataset();
  setTextualFilterView([]);
  setUnionKeysView([]);
  
  reInitializaAggregationTypes();
  setColorCircle("red.500");
  setPageSelected("selected_operation");
}, []); // Array vuoto

  return (
    <Box position="relative" height="100vh" width="100%" bg="#f6f3ec">
{/*<AISQLGenerator fetchCatalog={fetchCatalog} fetchColumns={fetchColumns} executeSQLAIGenerated={executeSQLAIGenerated}    handleClickEseguiAISQLGenerator={handleClickEseguiAISQLGenerator} axiosInstance={axiosInstance}  text2queryResponse={text2queryResponse} ></AISQLGenerator> */}

      
      {isLoadingModalAI && (
        <Box
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          bg="rgba(0, 0, 0, 0.7)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex="9999"
          flexDirection="column"
        >
          <VStack spacing={4} bg="white" p={8} borderRadius="xl" boxShadow="2xl">
            <Spinner size="xl" color="green.500" thickness="4px" />
            <VStack spacing={2}>
              <Text fontSize="lg" fontWeight="bold" color="gray.700">
                {t("queryTool.modalAI.generationInProgress")}
              </Text>
              <Text fontSize="sm" color="gray.500" textAlign="center">
                  {t("queryTool.modalAI.aiAnalyzingQuery")} 
                <br />
                  {t("queryTool.modalAI.pleaseWait")} 
              </Text>
            </VStack>
          </VStack>
        </Box>
      )}
      <DndProvider backend={HTML5Backend}>    
        <Grid templateColumns="repeat(5, 1fr)" height="100vh" gap={4} p={2}>
          {/* Drag and Drop area */}
          <DroppableArea                      
            onDrop={handleDrop}
            pageSelected={pageSelected}
            setPageSelected={setPageSelected}
            colorCircle={colorCircle}
            setColorCircle={setColorCircle}
            handleClickEsegui={handleClickEsegui}
            pulisci={pulisci}
            setDatasetView={setDatasetView}
            setOperation={setOperation}
            setColumnsDropped={setColumnsDropped}
            columnsDropped={columnsDropped}
            operation={operation}
            columnsDroppedFirstUnionDataset={columnsDroppedFirstUnionDataset}
            columnsDroppedSecondUnionDataset={columnsDroppedSecondUnionDataset}

            setAggregationView={setAggregationView}
            aggregationView={aggregationView}
            matematicalFilterView={matematicalFilterView}
            setMatematicalFilterView={setMatematicalFilterView}
            textualFilterView={textualFilterView}
            setTextualFilterView={setTextualFilterView}
            columnsFirstUnionDataset={columnsFirstUnionDataset}
            setColumnsDroppedFirstUnionDataset={setColumnsDroppedFirstUnionDataset}
            setColumnsDroppedSecondUnionDataset={setColumnsDroppedSecondUnionDataset}
            setFirstUnionDataset={setFirstUnionDataset}
            setSecondUnionDataset={setSecondUnionDataset}
            handleIconClickDeSelectAllColumnsFirstDataset={handleIconClickDeSelectAllColumnsFirstDataset}
            handleIconClickDeSelectAllColumnsSecondDataset={handleIconClickDeSelectAllColumnsSecondDataset}
            handleIconClickDataset={handleIconClickDataset}
            setUnionKeysView={setUnionKeysView}
            unionKeysView={unionKeysView}
            buttonsOperationJoin={buttonsOperationJoin}
            buttonsOperationSelect={buttonsOperationSelect}
            i18n={i18n}
            t={t}
            selectedOperationId={selectedOperationId}
            setSelectedOperationId={setSelectedOperationId}
          >

            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" >
            <Flex gap={2} display="flex" flexDirection="row" justifyContent="center" w={"100%"} h={"auto"} mt={2}> 
              {firstUnionDataset != null ? (
                <Flex display="flex" flexDirection="column" alignItems="center" w="30%" border="2px solid" borderColor="rgba(23, 141, 161, 1)" borderRadius="md" p={2}>
                  <Text fontSize="md" mb={2} color="rgba(11,78,90,255)" fontWeight="bold">{t("queryTool.droppableArea.first")} Dataset</Text>
                  <Button
                    key={uuidv4()}
                    w="100%"
                    color="white"           
                    _hover="none"
                    bg={ getBackgroundColorByVisibility(catalog.find(cat => cat.table_name == firstUnionDataset).visibility)}
                    borderWidth={1}
                    borderColor={"black"}
                    h="auto"
                    p={3}
                    whiteSpace="normal"
                    wordBreak="break-word"
                  >
                    {firstUnionDataset}
                  </Button>
                </Flex>
              ): ("")}

              {operation != null && (
                <Flex display="flex" flexDirection="column" alignItems="center" w="40%" border="2px solid" borderColor="rgba(23, 141, 161, 1)" borderRadius="md" p={2}>
                  <Text fontSize="md" mb={2} color="rgba(11,78,90,255)" fontWeight="bold">{t("queryTool.droppableArea.operation")}</Text>
                  <Button key={operation}  
                    color="white"     
                    w="100%"      
                    fontWeight="semibold"  
                    bgGradient="linear(to-r, teal.400, teal)"
                    borderWidth={1}
                    borderColor={"black"}
                    h="auto"
                    p={3}
                    whiteSpace="normal"
                    wordBreak="break-word"
                    transition="none"                
                    _hover={{
                      bgGradient: "linear(to-r, teal.400, teal)",  
                    }}
                    _active={{
                      bgGradient: "linear(to-r, teal.400, teal)",  
                    }}
                    _focus={{
                      boxShadow: "none",             
                    }}
                    _focusVisible={{
                      boxShadow: "none",
                    }}
                  >
                    {operation}
                  </Button>
                </Flex>
              )}

              {secondUnionDataset !=null  ? (
                <Flex display="flex" flexDirection="column" alignItems="center" w="30%" border="2px solid" borderColor="rgba(23, 141, 161, 1)" borderRadius="md" p={2}>
                  <Text fontSize="md" mb={2} color="rgba(11,78,90,255)" fontWeight="bold">{t("queryTool.droppableArea.second")} Dataset</Text>
                  <Button
                    key={uuidv4()}
                    w="100%" 
                    color="white"           
                    _hover="none"
                    bg={ getBackgroundColorByVisibility(catalog.find(cat => cat.table_name == secondUnionDataset).visibility)}
                    borderWidth={1}
                    borderColor={"black"}
                    h="auto"
                    p={3}
                    whiteSpace="normal"
                    wordBreak="break-word"
                  >
                    {secondUnionDataset}
                  </Button>
                </Flex>
              ):("")}

              {datasetView != null ? (
                <Flex display="flex" flexDirection="column" alignItems="center" w="30%" border="2px solid" borderColor="rgba(23, 141, 161, 1)" borderRadius="md" p={2}>
                  <Text fontSize="md" mb={2} color="rgba(11,78,90,255)" fontWeight="bold">Dataset</Text>

                  <Button
                    key={uuidv4()}
                    w="100%" 
                    color="white"           
                    _hover="none"
                    bg={ getBackgroundColorByVisibility(catalog.find(cat => cat.table_name == datasetView).visibility)}
                    borderWidth={1}
                    borderColor={"black"}
                    h="auto"
                    p={3}
                    whiteSpace="normal"
                    wordBreak="break-word"
                  >
                    {datasetView}
                  </Button>
                </Flex>
              ):("")}

            </Flex>

              {columnsDropped.length >0 && (
                <Button 
                  colorScheme="blue"
                  borderWidth={1}
                  borderColor={"black"}
                  m={5}
                  onClick={handleIconClickDeSelectAllColumns}
                >
                  {t("queryTool.deselect_all")}
                </Button>
              )}

              <Grid templateColumns="repeat(2, 1fr)" gap={2} overflowY="auto" maxH="calc(100vh - 300px)" w="100%">

                {columnsDropped.map((item, index) => (
                  <Button
                    mt={"10%"} w="95%" 
                    colorScheme="teal"
                    key={index}
                    borderWidth={1}
                    borderColor={"black"}
                    m={1}
                    whiteSpace="normal"
                    wordBreak="break-word"
                    h="auto"
                    px={3}
                    py={1}
                    _hover={{
                        bg: "rgba(8, 60, 70, 255)", 
                        color: "white"
                    }}
                  >
                    {item}

                    {pageSelected !== "add_aggregation_view" && pageSelected !== "add_filter" && (
                        <Icon
                          as={MdDelete} // Change this to the icon you want
                          boxSize={5}
                          // Add click handler
                          onClick={() => handleIconClickColumns(item)}
                          cursor="pointer"
                          ml={2} // Margin left to space the icon from the text
                          _hover={{
                              color: "red.400"
                          }}
                        />
                    )}
                  </Button>
                ))}
              </Grid>
            <Box maxH="50vh"overflowY="auto"
              w="100%"
            >
              {/* Primo dataset union */}
              {columnsDroppedFirstUnionDataset.length > 0 && (
                <Box w="100%" mt={4}>
                  <Flex justify="space-between" align="center" gap={2}>
                    <Text fontSize="sm" color="rgba(11,78,90,255)" mb={2} fontWeight="bold">{t("queryTool.column_first_dataset")}  :</Text>
                    {columnsDroppedFirstUnionDataset.length > 0 && (
                      <Button
                        mb={2}
                        mr={2}
                        colorScheme="blue"
                        borderWidth={1}
                        borderColor="black"
                        size="xs"
                        // width="full"
                        onClick={handleIconClickDeSelectAllColumnsFirstDataset}
                      >
                          {t("queryTool.deselect_all")}
                      </Button>
                    )}
                  </Flex>
                  <Box
                    // maxHeight="150px"
                    // overflowY="auto"
                    border="1px solid"
                    borderColor="rgba(23, 141, 161, 1)"
                    borderRadius="md"
                    p={2}
                  >
                    <Flex flexWrap="wrap" gap={2}>
                      {columnsDroppedFirstUnionDataset.map((item, index) => (
                        <Button
                          key={index}
                          bg="teal"
                          color= "white"
                          borderWidth={1}
                          borderColor="black"
                          size="sm"           // Cambiato da "xs" a "sm"
                          fontSize="sm"       // Cambiato da "xs" a "sm"
                          minWidth="auto"
                          px={3}              // Aumentato da 2 a 3
                          py={2}              // Aggiunto padding verticale
                          height="auto"       // Permette altezza flessibile
                          _hover={{
                              bg: "rgba(8, 60, 70, 255)", 
                              color: "white"
                          }}
                          rightIcon={
                            <Icon
                              as={MdDelete}
                              boxSize={4}       // Aumentato da 3 a 4
                              onClick={() => handleIconClickColumnsFirstUnionDataset(item)}
                              cursor="pointer"
                              _hover={{
                                  color: "red.400"
                              }}
                            />
                          }
                        >
                          <Text isTruncated maxWidth="150px">  {/* Aumentato da 120px a 150px */}
                            {item}
                          </Text>
                        </Button>
                      ))}
                    </Flex>
                  </Box>
                </Box>
              )}

              {/* Secondo dataset union */}
              {columnsDroppedSecondUnionDataset.length > 0 && (
                <Box w="100%" mt={4}>
                  <Flex justify="space-between" align="center" gap={2}>
                    <Text fontSize="sm" mb={2} color="rgba(11,78,90,255)" fontWeight="bold">{t("queryTool.column_second_dataset")}:</Text>
                    {columnsDroppedSecondUnionDataset.length > 0 && (
                      <Button
                        mb={2}
                        mr={2}
                        colorScheme="blue"
                        borderWidth={1}
                        borderColor="black"
                        size="xs"
                        // width="full"
                        onClick={handleIconClickDeSelectAllColumnsSecondDataset}
                      >
                        {t("queryTool.deselect_all")}
                      </Button>
                    )}
                  </Flex>
                  <Box
                    border="1px solid"
                    borderColor="rgba(23, 141, 161, 1)"     
                    borderRadius="md"
                    p={2}
                  >
                    <Flex flexWrap="wrap" gap={2}>
                      {columnsDroppedSecondUnionDataset.map((item, index) => (
                        <Button
                          key={index}
                          bg="teal"
                          color= "white"
                          borderWidth={1}
                          borderColor="black"
                          size="sm"           // Cambiato da "xs" a "sm"
                          fontSize="sm"       // Cambiato da "xs" a "sm"
                          minWidth="auto"
                          px={3}              // Mantenuto a 3
                          py={2}              // Aggiunto padding verticale
                          height="auto"       // Permette altezza flessibile
                          _hover={{
                              bg: "rgba(8, 60, 70, 255)", 
                              color: "white"
                          }}
                          rightIcon={
                            <Icon
                              as={MdDelete}
                              boxSize={4}       // Aumentato da 3 a 4
                              onClick={() => handleIconClickColumnsSecondUnionDataset(item)}
                              cursor="pointer"
                              _hover={{
                                  color: "red.400"
                              }}
                            />
                          }
                        >
                          <Text isTruncated maxWidth="150px">  {/* Aumentato da 120px a 150px */}
                            {item}
                          </Text>
                        </Button>
                      ))}
                    </Flex>
                  </Box>
                </Box>
              )}
            </Box>
            </Box>
          </DroppableArea>

          {/* Operation List */}
          <GridItem colSpan={2} border="2px dashed" borderColor="gray.300" borderRadius="md" p={4}>

            {pageSelected == "selected_operation" && (
                <Box>
                  <Box mb={4} fontSize="xl" fontWeight="bold" color="rgba(11,78,90,255)" >
                    {t("queryTool.droppableArea.operations")}
                  </Box>
                  <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                    {buttonsOperationSelect.map((buttonOperationSelect, index) => (
                      <DraggableItemCustom
                        key={buttonOperationSelect.id}
                        id={{id:buttonOperationSelect.label,sqlId: buttonOperationSelect.id}}
                        text={buttonOperationSelect.label}
                      />
                    ))}
                  </Grid>

                  <Divider mb={3} mt={9} width="100%" borderColor="gray.300" />
          
                  <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                    {buttonsOperationJoin.map((buttonOperationJoin, index) => (
                        <DraggableItemCustom
                          key={buttonOperationJoin.id}
                          id={{id:buttonOperationJoin.label,sqlId: buttonOperationJoin.id}}
                          text={buttonOperationJoin.label}
                        />
                    ))}
                  </Grid>
            
                </Box>
            ) } 

            {pageSelected == "selected_dataset" && (
              <Box>
                <Box flex="3" borderWidth={2} overflowY="scroll" height={{ base: "50vh", md: "70vh", lg: "80vh" }}>

                  <Box justifyContent="space-between">
                    <Heading fontSize="lg">Dataset</Heading>
                    <Box w="100%" justifyContent="space-between">
                      {t('queryTool.legend')}:
                      <Badge colorScheme="green" variant="solid">Private</Badge>
                      <Badge colorScheme="yellow" variant="solid">Public</Badge>
                      <Badge colorScheme="orange" variant="solid">Obtained</Badge>
                      <Badge colorScheme="blue" variant="solid">General</Badge>
                    </Box>
                  </Box>

                  <Box justifyContent="space-between" mt={"1%"}>
                    <Heading fontSize="lg">Catalog</Heading>
                    <Box w="100%" justifyContent="space-between">
                      {t('queryTool.legend')}:
                      <Badge colorScheme="blue" variant="solid">General</Badge>
                      <Badge colorScheme="green" variant="solid">Results</Badge>
                      <Badge colorScheme="orange" variant="solid">Processing</Badge>
                      <Badge colorScheme="purple" variant="solid">Staging</Badge>
                    </Box>
                  </Box>

                  {/* Suddivisione per Aree */}
                  {[
                    { id: 1, name: "Catalog General", type: "catalogo_generale", color: "blue" },
                    { id: 2, name: "Catalog Results", type: "catalogo_risultati", color: "green" },
                    { id: 3, name: "Catalog Processing", type: "catalogo_elaborazioni", color: "orange" },
                    { id: 4, name: "Catalog Staging", type: "catalogo_staging", color: "purple" },
                  ].map(({ id, name, color }) => {
                    const filteredCatalog = catalog.filter(item => Number(item.cataloguetype_id) === id);

                    console.log(`Catalogo per ${name}:`, filteredCatalog); // Debug per vedere i dati filtrati

                    return (
                      <Box key={id} mt={4} p={3} borderRadius="md" borderWidth={2} borderColor={`${color}.500`}>
                        <Heading fontSize="md" color={`${color}.600`} mb={2}>{name}</Heading>

                        {filteredCatalog.length > 0 ? (
                          filteredCatalog.map(({ table_id, table_name, visibility }) => (
                            <DraggableItem
                              key={table_id}
                              id={{ id: table_name, type: "dataset" }}
                              text={table_name}
                              visibility={visibility}
                            />
                          ))
                        ) : (
                          <Text color="gray.500">{t('queryTool.noDatasetPresent')}</Text>
                        )}
                      </Box>
                    );
                  })}

                </Box>          
              </Box>
            ) } 

            {(pageSelected === "selected_first_dataset" || pageSelected === "selected_second_dataset") && (
              <Box flex="3" borderWidth={2} overflowY="scroll" height={{ base: "50vh", md: "70vh", lg: "80vh" }}>

                <Box justifyContent="space-between">
                  <Heading fontSize="lg">Dataset</Heading>
                  <Box w="100%" justifyContent="space-between">
                    {t('queryTool.legend')}:
                    <Badge colorScheme="green" variant="solid">Private</Badge>
                    <Badge colorScheme="yellow" variant="solid">Public</Badge>
                    <Badge colorScheme="orange" variant="solid">Obtained</Badge>
                    <Badge colorScheme="blue" variant="solid">General</Badge>
                  </Box>
                </Box>

                <Box justifyContent="space-between" mt={"1%"}>
                  <Heading fontSize="lg">Catalog</Heading>
                  <Box w="100%" justifyContent="space-between">
                    {t('queryTool.legend')}:
                    <Badge colorScheme="blue" variant="solid">General</Badge>
                    <Badge colorScheme="green" variant="solid">Results</Badge>
                    <Badge colorScheme="orange" variant="solid">Processing</Badge>
                    <Badge colorScheme="purple" variant="solid">Staging</Badge>
                  </Box>
                </Box>

                {/* Suddivisione per Aree */}
                {[
                  { id: 1, name: "Catalog General", type: "catalogo_generale", color: "blue" },
                  { id: 2, name: "Catalog Results", type: "catalogo_risultati", color: "green" },
                  { id: 3, name: "Catalog Processing", type: "catalogo_elaborazioni", color: "orange" },
                  { id: 4, name: "Catalog Staging", type: "catalogo_staging", color: "purple" },
                ].map(({ id, name, color }) => {
                  const filteredCatalog = catalog.filter(item => Number(item.cataloguetype_id) === id);

                  console.log(`Catalogo per ${name}:`, filteredCatalog); // Debug per vedere i dati filtrati

                  return (
                    <Box key={id} mt={4} p={3} borderRadius="md" borderWidth={2} borderColor={`${color}.500`}>
                      <Heading fontSize="md" color={`${color}.600`} mb={2}>{name}</Heading>

                      {filteredCatalog.length > 0 ? (
                        filteredCatalog.map(({ table_id, table_name, visibility }) => (
                          <DraggableItem
                            key={table_id}
                            id={{ id: table_name, type: "dataset" }}
                            text={table_name}
                            visibility={visibility}
                          />
                        ))
                      ) : (
                        <Text color="gray.500">{t('queryTool.noDatasetPresent')}</Text>
                      )}
                    </Box>
                  );
                })}

              </Box>
            )}

            {pageSelected == "selected_attibute" && pageSelected !== "add_aggregation_view" && (
              <Box>
                <Box mb={4} fontSize="xl" fontWeight="bold" color="rgba(11,78,90,255)" >
                  {t("queryTool.columnDatasetSelected")}  
                  <Button
                    size={"sm"}
                    borderWidth={1}
                    colorScheme="blue"
                    ml={3}
                    onClick={handleIconClickSelectAllColumns}
                  >
                    {t("queryTool.select_all")}
                  </Button>
                </Box>

                <Grid templateColumns="repeat(2, 1fr)" gap={2} maxH="70vh"overflowY="auto" w="100%">
                  
                  {columns.length > 0 ? (
                    columns.map((item) => (
                      <DraggableItemCustom key={item} id={{ id: item, type: "column" }} text={item} />
                    ))
                  ) : (
                    <p>{t("queryTool.droppableArea.noColumnAvailable")}</p>
                  )}

                </Grid>

              </Box>
            ) } 

            { pageSelected === "add_aggregation_view" && aggregationView != null && columnsDropped.length >0
              ? (
                  //Punto Secondo
                  <Box>
                    <Button
                      bgGradient="linear(to-r, teal.400, blue.500)"
                      color="white"
                      borderWidth={2}
                      borderColor="teal.500"
                      borderRadius="md"
                      m={2}
                      px={4}
                      py={2}
                      mx="auto"  // Centra orizzontalmente
                      display="block"  // Necessario per mx="auto"
                      _hover={{
                        bgGradient: "linear(to-r, blue.500, teal.400)",
                        transform: "scale(1.05)",
                        boxShadow: "xl",
                      }}
                      _active={{
                        bgGradient: "linear(to-r, teal.500, blue.600)",
                        transform: "scale(0.98)",
                      }}
                      _focus={{
                      outline: "none",
                      boxShadow: "outline",
                      }}
                      onClick={() => addAggregationView(uuidv4())}
                    >
                      {t("queryTool.droppableArea.addColumnAggregation")}
                    </Button>
                    <Box
                      maxH="calc(100vh - 150px)"
                      overflowY="auto" 
                      w="100%"
                      mb={4}
                      margin={1}
                      borderWidth={2}
                      borderRadius="md"
                      borderColor="rgba(23, 141, 161, 1)"
                      bg="#f6f3ec"
                      p={2}
                    >
                      <Text id="title-operation" fontSize="lg" fontWeight="bold" color="rgba(11,78,90,255)" textAlign={"center"}>
                        {" "}
                          {t("queryTool.droppableArea.createNewColumnAggregation")}
                      </Text>

                      {aggregationView.map((item, index) => (
                        <Box key={item.id || index} borderWidth={2} borderRadius="md" borderColor="rgba(23, 141, 161, 1)" p={2} mb={2}> 

                          {item.operation !== "COUNT" ? (
                            <Box >
                              <Select onChange={(e) => handleChangeAggregationView(e.target.value, item, "attribute" )} bg="white">
                                {columnsCopy.filter(col => !columnsDropped.includes(col)).map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </Select>

                              <Select my={2} onChange={(e) => handleChangeAggregationView(e.target.value, item, "operation" )} bg="white">
                                {aggregationTypes.map((option) => (
                                  <option
                                  key={option.label}
                                  value={option.label}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </Select>
                            </Box>

                          ): (  
                            getCOUNT()
                          )}
                        <Flex align="center">
                          <Input bg="white" onChange={(e) => handleChangeAggregationView(e.target.value, item, "columnAlias" )} placeholder={t("queryTool.insert_column_alias")} />
                          
                          <Icon
                            as={MdDelete} // Change this to the icon you want
                            boxSize={5}
                            onClick={() => removeAggregationView(item)}
                            cursor="pointer"
                            ml={2}
                            color="rgba(23, 141, 161, 1)"
                            _hover={{
                                color: "red.400"
                            }}
                          />
                        </Flex>
                        </Box>
                      
                      ))}
                    </Box>
                  </Box>
              ) : (
                ""
            )}

            { pageSelected === "add_filter"&& datasetView != null && columnsDropped.length >0  ? (
              <Box>
                <Flex justify="center" gap={4} m={2}>
                  <Button
                    bgGradient="linear(to-r, teal.400, blue.500)"
                    color="white"
                    borderWidth={2}
                    borderColor="teal.500"
                    borderRadius="md"
                    px={4}
                    py={2}
                    _hover={{
                    bgGradient: "linear(to-r, blue.500, teal.400)",
                    transform: "scale(1.05)",
                    boxShadow: "xl",
                    }}
                    _active={{
                    bgGradient: "linear(to-r, teal.500, blue.600)",
                    transform: "scale(0.98)",
                    }}
                    _focus={{
                    outline: "none",
                    boxShadow: "outline",
                    }}
                    onClick={() => addMatematicFilterView(uuidv4())}
                  >
                    {t("queryTool.droppableArea.mathematicalFilter")}
                  </Button>

                  <Button
                    bgGradient="linear(to-r, teal.400, blue.500)"
                    color="white"
                    borderWidth={2}
                    borderColor="teal.500"
                    borderRadius="md"
                    px={4}
                    py={2}
                    _hover={{
                    bgGradient: "linear(to-r, blue.500, teal.400)",
                    transform: "scale(1.05)",
                    boxShadow: "xl",
                    }}
                    _active={{
                    bgGradient: "linear(to-r, teal.500, blue.600)",
                    transform: "scale(0.98)",
                    }}
                    _focus={{
                    outline: "none",
                    boxShadow: "outline",
                    }}
                    onClick={() => addTextualFilterView(uuidv4())}
                  >
                    {t("queryTool.droppableArea.textualFilter")}
                  </Button>
                </Flex>

                <Box
                  maxH="calc(100vh - 150px)"
                  overflowY="auto" 
                  w="100%"
                  mb={4}
                  margin={1}
                  bg="#f6f3ec"
                >
                  <Text id="title-operation" fontSize="lg" fontWeight="bold" color="rgba(11,78,90,255)" textAlign={"center"}>
                    {" "}
                    {t("queryTool.droppableArea.createNewFilter")}
                  </Text>

                  {matematicalFilterView.map((item,index) => (
                    <Box key={item.id || index} borderWidth={2} borderRadius="md" borderColor="rgba(23, 141, 161, 1)" p={2} mb={2}>
                      <Text fontSize="sm" fontWeight="bold" color="rgba(23, 141, 161, 1)" my={2}> {t("queryTool.droppableArea.mathematicalFilter")} {index+1}º </Text>
                      <Select onChange={(e) => handleChangeMatematicalFilterView(e.target.value, item, "attribute" )} bg="white">
                        {columnsDropped.map((option) => (
                          <option
                            key={option}
                            value={option}
                          >
                            {option}
                          </option>
                        ))}
                      </Select>

                      <Select my={2} onChange={(e) => handleChangeMatematicalFilterView(e.target.value, item, "operation" )} bg="white">
                        {getMatTypes().map((option) => (
                          <option
                            key={option.id}
                            value={option.id}
                          >
                            {option.id}
                          </option>
                        ))}
                      </Select>
                      <Flex align="center">
                        <Input 
                          type='number'
                          onChange={(e) => handleChangeMatematicalFilterView(e.target.value, item, "userInput" )}
                          placeholder="Insert number" 
                          bg="white"
                        />

                        <Icon
                          as={MdDelete} // Change this to the icon you want
                          boxSize={5}
                          onClick={() => removeMatematicFilterView(item)}
                          cursor="pointer"
                          ml={2}
                          color="rgba(23, 141, 161, 1)"
                          _hover={{
                              color: "red.400"
                          }}
                        />
                      </Flex>
                    </Box>
                  ))}

                  {textualFilterView.map((item, index) => (
                    <Box key={item.id || index} borderWidth={2} borderRadius="md" borderColor="rgba(23, 141, 161, 1)" p={2} mb={2}>
                      <Text fontSize="sm" fontWeight="bold" color="rgba(23, 141, 161, 1)" my={2}> {t("queryTool.droppableArea.textualFilter")} {index+1}º </Text>
                      <Select onChange={(e) => handleChangeTextualFilterView(e.target.value, item, "attribute" )} bg="white">
                        {columnsDropped.map((option) => (
                          <option
                            key={option}
                            value={option}
                          >
                            {option}
                          </option>
                        ))}
                      </Select>

                      <Select my={2} onChange={(e) => handleChangeTextualFilterView(e.target.value, item, "operation" )} bg="white">
                        {getTextTypes().map((option) => (
                          <option
                            key={option.id}
                            value={option.id}
                          >
                            {option.id}
                          </option>
                        ))}
                      </Select>
                      <Flex align="center">
                        <Input
                          onChange={(e) => handleChangeTextualFilterView(e.target.value, item, "userInput" )}
                          placeholder="Insert text" 
                          bg="white"
                        />

                        <Icon
                          as={MdDelete} // Change this to the icon you want
                          boxSize={5}
                          onClick={() => removeTextualFilterView(item)}
                          cursor="pointer"
                          ml={2}
                          color="rgba(23, 141, 161, 1)"
                          _hover={{
                              color: "red.400"
                          }}
                        />

                      </Flex>
                    </Box>
                  ))}
                </Box>
              </Box>
              ) : (
                ""
            )}

            {pageSelected == "add_union_key" && firstUnionDataset != null && secondUnionDataset != null  && columnsDroppedFirstUnionDataset.length >0 && columnsDroppedSecondUnionDataset.length >0 ? (
              <Box
                  maxH="calc(100vh - 100px)"
                  overflowY="auto" 
                  w="100%"
                  margin={1}
              >
                <Text mb={2} id="title-operation" fontSize="lg" fontWeight="bold" color="rgba(11,78,90,255)" textAlign={"center"}>
                  {" "}
                  {t("queryTool.select_key_of_union")}

                  <Icon
                    as={MdAdd} // Change this to the icon you want
                    boxSize={7}
                    onClick={() => addUnionKeysView(uuidv4())}
                    cursor="pointer"
                    ml="50%" // Margin left to space the icon from the text
                  />
                </Text>
              
                {unionKeysView.map((item, index) => (
                  <Box key={item.id || index} borderWidth={2} borderRadius="md" borderColor="rgba(23, 141, 161, 1)" p={2} mb={2}>
                    <Flex justify="space-between" align="center" mb={2}>
                      <Text fontSize="sm" fontWeight="bold" color="rgba(23, 141, 161, 1)"> {t("queryTool.key_union")} {index+1}º </Text>
                      <Icon
                        as={MdDelete} // Change this to the icon you want
                        boxSize={5}
                        onClick={() => removeUnionKeysView(item)}
                        cursor="pointer"
                        mr={2}
                        color="rgba(23, 141, 161, 1)"
                        _hover={{
                          color: "red.400"
                        }}
                      />
                    </Flex>
                    <Select my={2} onChange={(e) => handleChangeUnionKeysView(e.target.value, item, t("queryTool.column_first_dataset") )} bg="white">
                      {columnsFirstUnionDatasetCopy.map((option) => (
                        <option
                          key={option}
                          value={option}
                        >
                          {option}
                        </option>
                      ))}
                    </Select>

                    <Select onChange={(e) => handleChangeUnionKeysView(e.target.value, item,t("queryTool.column_second_dataset") )} bg="white">
                      {columnsSecondUnionDatasetCopy.map((option) => (
                        <option
                        key={option}
                          value={option}
                        >
                          {option}
                        </option>
                      ))}
                    </Select>

                  </Box>
                ))}

              </Box>
            ): ("")}

            {pageSelected == "selected_attibute_first_dataset" && (
              <Box>
                <Box mb={4} fontSize="xl" fontWeight="bold" color="rgba(11,78,90,255)" >
                  {t("queryTool.columnsFirstDatasetSelected")}
                  <Button
                    size={"sm"}
                    borderWidth={1}
                    colorScheme="blue"
                    ml={3}
                    onClick={handleIconClickSelectAllColumnsFirstDataset}
                  >
                    {t("queryTool.select_all")}
                  </Button>
                </Box>

                <Grid templateColumns="repeat(2, 1fr)" gap={2}  overflowY="auto" maxHeight="400px">
                  
                {columnsFirstUnionDataset.length > 0 ? (
                  columnsFirstUnionDataset.map((item) => (
                    <DraggableItemCustom key={item} id={{id: item, type: "first"}} text={item} />
                      ))
                    ) : (
                      <p>{t("queryTool.droppableArea.noColumnAvailable")}</p>
                  )}
                </Grid>

              </Box>
            ) }
            
            {pageSelected == "selected_attibute_second_dataset" && (
              <Box>
                <Box mb={4} fontSize="xl" fontWeight="bold" color="rgba(11,78,90,255)" >
                  {t("queryTool.columnsSecondDatasetSelected")}
                  <Button
                    size={"sm"}
                    borderWidth={1}
                    colorScheme="blue"
                    ml={3}
                    onClick={handleIconClickSelectAllColumnsSecondDataset}
                  >
                    {t("queryTool.select_all")}
                  </Button>
                </Box>

                <Grid templateColumns="repeat(2, 1fr)" gap={2}  overflowY="auto" maxHeight="400px">
                  
                  {columnsSecondUnionDataset.length > 0 ? (
                    columnsSecondUnionDataset.map((item) => (
                      <DraggableItemCustom key={item} id={{id: item, type: "second"}} text={item} />
                    
                    ))
                  ) : (
                    <p>{t("queryTool.droppableArea.noColumnAvailable")}</p>
                  )}

                </Grid>

              </Box>
            ) } 
        
          </GridItem>
        </Grid>
      </DndProvider>

      {/* Bottoni sotto al componente principale */}

      {generalLoading && (
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          bg="rgba(255, 255, 255, 0.8)" // Semi-transparent background
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex="1000" // Ensure it overlays other content
        >
          <Center>
            <Spinner size="xl" />
          </Center>
        </Box>
      )}
    
      <Modal isOpen={isModalResultAIOpen} onClose={closeResulAItModal} size="2xl" isCentered>
        <ModalOverlay 
          bg="blackAlpha.300" 
          backdropFilter="blur(10px)" 
        />
        <ModalContent 
          bg="white"
          borderRadius="20px"
          overflow="hidden"
          boxShadow="0 25px 50px rgba(0, 0, 0, 0.15)"
          border="1px solid"
          borderColor="gray.100"
        >
          {/* Header con gradiente verde */}
          <ModalHeader 
            bg="linear-gradient(135deg, #48bb78 0%, #38a169 100%)"
            color="white"
            py={6}
            textAlign="center"
            position="relative"
          >
            <VStack spacing={2}>
              <HStack spacing={3}>
                <Icon as={FaRobot} w={6} h={6} />
                <Text fontSize="xl" fontWeight="bold">
                  {t("queryTool.modalAI.aiTitle")}
                </Text>
              </HStack>
              <Text fontSize="sm" opacity={0.9} fontWeight="normal">
                {t("queryTool.modalAI.generatedByAi")}
              </Text>
            </VStack>
            <ModalCloseButton 
              color="white" 
              _hover={{ bg: "whiteAlpha.200" }}
              size="lg"
              borderRadius="full"
            />
          </ModalHeader>

          <ModalBody p={8}>
            {/* Pulsante di generazione migliorato */}
            <VStack spacing={6}>
              <Button
                leftIcon={<FaSync />}
                colorScheme="green"
                bg="linear-gradient(135deg, #48bb78 0%, #38a169 100%)"
                _hover={{
                  bg: "linear-gradient(135deg, #4fd1c7 0%, #38a169 100%)",
                  transform: "translateY(-3px)",
                  shadow: "xl"
                }}
                _active={{
                  transform: "translateY(-1px)",
                  shadow: "lg"
                }}
                isLoading={isLoadingModalAI}
                loadingText="Generando..."
                onClick={() => {
                  setIsLoadingModalAI(true)
                        text2queryResponse(query, null).then(res => {
                        
                          if(res && res.llmResponse) {
                            setTextAI(res.llmResponse)
                          }
                        setIsModalResultAIOpen(true)
                            setIsLoadingModalAI(false)
                        }).catch(()=> {
                            setIsLoadingModalAI(false)
                        })
                }}
                size="lg"
                borderRadius="full"
                px={8}
                py={3}
                transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                boxShadow="0 10px 25px rgba(72, 187, 120, 0.4)"
                fontSize="md"
                fontWeight="semibold"
                color="white"
                minW="200px"
                position="relative"
                overflow="hidden"
                _before={{
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                  transition: 'left 0.5s',
                }}
                
              >
                <HStack spacing={2}>
                  <Icon as={FaMagic} w={4} h={4} />
                  <Text>{t("queryTool.modalAI.regenerateSqlDescription")}</Text>
                </HStack>
              </Button>

              {/* Area di testo migliorata */}
              <Box w="full" position="relative">
                <Text 
                  fontSize="sm" 
                  fontWeight="semibold" 
                  color="gray.600" 
                  mb={3}
                  display="flex"
                  alignItems="center"
                  gap={2}
                >
                  <Icon as={FaFileAlt} w={4} h={4} />
                  {t("queryTool.modalAI.sqlDescriptionGenerated")}
                </Text>
                
                <Box position="relative">
                  <Textarea
                    value={textAI}
                    placeholder= {`${t("queryTool.modalAI.aiTextPlaceholder")} ${t("queryTool.modalAI.generateButtonHint")}`}
                    minH="250px"
                    resize="vertical"
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    borderRadius="15px"
                    p={4}
                    fontSize="md"
                    lineHeight="1.6"
                    _hover={{
                      borderColor: "green.300",
                      bg: "white"
                    }}
                    _focus={{
                      borderColor: "green.500",
                      bg: "white",
                      boxShadow: "0 0 0 1px var(--chakra-colors-green-500)"
                    }}
                    transition="all 0.2s ease"
                    _placeholder={{
                      color: "gray.400",
                      fontSize: "sm"
                    }}
                  />
                  
                  {/* Contatore caratteri */}
                  <Text
                    position="absolute"
                    bottom={3}
                    right={3}
                    fontSize="xs"
                    color="gray.500"
                    bg="white"
                    px={2}
                    py={1}
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    {textAI?.length || 0} {t("queryTool.modalAI.characters")}
                  </Text>
                </Box>
              </Box>

              {/* Info card */}
              {!textAI && (
                <Box
                  w="full"
                  bg="green.50"
                  border="1px solid"
                  borderColor="green.200"
                  borderRadius="12px"
                  p={4}
                  textAlign="center"
                >
                  <VStack spacing={2}>
                    <Icon as={FaLightbulb} w={6} h={6} color="green.500" />
                    <Text fontSize="sm" color="green.700" fontWeight="medium">
                      <strong>{t("queryTool.modalAI.warning")}:</strong> {t("queryTool.modalAI.aiInaccuracyNotice")}
                      {t("queryTool.modalAI.accuracyCheckAdvice")}
                    </Text>
                  </VStack>
                </Box>
              )}
            </VStack>
          </ModalBody>

          {/* Footer migliorato */}
          <ModalFooter 
            bg="gray.50" 
            borderTop="1px solid" 
            borderColor="gray.200"
            px={8}
            py={4}
          >
            <HStack spacing={3} w="full" justify="space-between">
              <HStack spacing={2} color="gray.500" fontSize="sm">
                <Icon as={FaRobot} w={4} h={4} />
                <Text>Powered by AI</Text>
              </HStack>
              
              <HStack spacing={3}>
                {textAI && (
                  <Button
                    leftIcon={<FaCopy />}
                    variant="outline"
                    colorScheme="green"
                    size="sm"
                    onClick={() => navigator.clipboard.writeText(textAI)}
                    borderRadius="full"
                  >
                    {t("queryTool.modalAI.copy")}
                  </Button>
                )}
                
                <Button 
                  onClick={closeResulAItModal}
                  variant="ghost"
                  colorScheme="gray"
                  size="md"
                  borderRadius="full"
                  px={6}
                >
                  {t("queryTool.modalAI.close")}
                </Button>
              </HStack></HStack>
            </ModalFooter>
          </ModalContent>
      </Modal>

      <Modal onClose={closeResultModal} isOpen={isModalResultOpen} isCentered closeOnOverlayClick={false} >
        <ModalOverlay />
        <ModalContent maxW="90%" maxH="90vh" h="auto">
          <ModalHeader
            bgColor={"#0888BE"}
            color={"white"}
            position="sticky"
            top={0}
            zIndex={10}
          >
            <Flex w="100%" justifyContent="space-between" alignItems="center" > {/* Muovere SAVE su lato DX del ModalHeader*/}
              {t('queryTool.catalogResults')}
   

              {/* Posizione iniziale del Save Button */}
              {/* Pagina 2/7 risultati etc... */}
              {/* {payloadRequestResult.window && objectPagination.max_window_num ? (
                <Box fontSize="15px" paddingLeft={"15px"} textAlign="left" flex={1} >
                  Pagina {payloadRequestResult.window}/{objectPagination.max_window_num}{" "}
                  <Spacer />Risultati {objectPagination.offset} -{" "}
                  {Math.min(payloadRequestResult.window * 100, objectPagination.totalLen)} di {objectPagination.totalLen}
                </Box>
              ) : (
                ""
              )} */}
              {/* Pagina 2/7 risultati etc... */}
              {/* INIZIO Nuova Posizione Paging Arrow Backward/Forward*/}
              <Flex justifyContent="center" alignItems="center" marginTop={4} marginBottom={4} marginLeft={-24} flex={2}>
                {payloadRequestResult.window > 1 ? (
                  <Tooltip label={t('toolTip.tooltipQueryTool.resultsModal.previousPage')} placement="left" closeOnClick={true}>
                    <span>
                      <Icon
                        as={MdArrowBack}
                        boxSize={6}
                        onClick={backResult}
                        cursor="pointer"
                        marginRight={4}
                      // marginLeft={8}
                      />
                    </span>
                  </Tooltip>

                ) : (
                  ""
                )}
                {/* Text In the Middle per migliorare la UX */}
                {payloadRequestResult.window && objectPagination.max_window_num ? (
                  <Box fontSize="15px" textAlign="center" mx={4} >
                    {t('catalog.dataset.page')} {payloadRequestResult.window}/{objectPagination.max_window_num}{" "}
                    <Spacer />{t('queryTool.results')} {objectPagination.offset} -{" "}
                    {Math.min(payloadRequestResult.window * 100, objectPagination.totalLen)} {t('catalog.dataset.of')} {objectPagination.totalLen}
                  </Box>
                ) : (
                  ""
                )}
                {/*Fine Text in the middle   */}
                {/* INIZIO Paging Arrow Forward */}
                {payloadRequestResult.window < objectPagination.max_window_num ? (
                  <Tooltip label={t('toolTip.tooltipQueryTool.resultsModal.nextPage')} placement="right" closeOnClick={true}>
                    <span>
                      <Icon
                        as={MdArrowForward}
                        boxSize={6}
                        onClick={nextResult}
                        cursor="pointer"
                        marginLeft={4}
                      // marginRight={8}
                      />
                    </span>
                  </Tooltip>
                ) : (
                  ""
                )}
                {/* FINE Paging Arrow Forward */}
              </Flex>
              {/* FINE Nuova Posizione Paging Arrow Backward/Forward*/}
                <Tooltip label={t('toolTip.tooltipQueryTool.resultsModal.aiQueryToText')} placement="bottom" closeOnClick={true}>
                  <IconButton
                    mr={3}
                    mt={2}
                    aria-label="AI Query to text"
                    icon={<TbBrain />}
                    bg="blue.500"
                    color="white"
                    size="xl"
                    _hover={{
                      transform: "translateY(-2px)",
                    }}
                    _active={{
                      transform: "translateY(0px)"
                    }}
                    transition="all 0.3s ease"
                    onClick={() => {
                    setIsLoadingModalAI(true)
                          text2queryResponse(query, null).then(res => {
                            
                            if(res && res.llmResponse) {
                              setTextAI(res.llmResponse)
                            }
                          setIsModalResultAIOpen(true)
                              setIsLoadingModalAI(false)
                          }).catch(()=> {
                              setIsLoadingModalAI(false)
                          })
                    }}
                  />
                </Tooltip>   

              {/* INIZIO Save Button Spostato */}
              {!isSimpleSelect &&(
                <Tooltip label={t('toolTip.tooltipQueryTool.resultsModal.saveResults')} placement="bottom" closeOnClick={true}>
                  <span>
                    <Icon
                      as={MdSave}
                      onClick={openaResultModal}
                      cursor="pointer"
                      mr={8}
                      bg="blue.500"
                      color="white"
                      size="xl"
                      _hover={{
                        transform: "translateY(-2px)",
                      }}
                      _active={{
                        transform: "translateY(0px)"
                      }}
                      transition="all 0.3s ease"
                    />
                  </span>
                </Tooltip>
              )}
              {/* FINE Save Button Spostato */}
            </Flex>

            <Text fontSize={"lg"} fontWeight={"bold"} color="yellowgreen"></Text>
            <Icon
              as={MdClose}
              boxSize={5}
              onClick={closeResultModal}
              cursor="pointer"
              position="absolute"
              top="8px"
              right="8px"
            />
          </ModalHeader>

          <ModalBody overflow={"auto"} h="100%" p={1}>
            {resultLoading ? (
              <Center height="600px">
                <Spinner size="xl" />
              </Center>
            ) : (
              <Box>
                <Table variant="striped" size={"sm"}>
                  <Thead bgColor={"#0888BE"} position="sticky" top={0} zIndex={9} fontWeight={"bold"}>
                    <Tr>
                      {keysResult
                        ? keysResult.map((key) => (
                          <Th
                            color={"white"}
                            key={key}
                            position="sticky"
                            top={0}
                            zIndex={9}
                            padding="8px"
                          >
                            {key}
                          </Th>
                        ))
                        : ""}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {resultData.length > 0
                      ? resultData.slice(0, 100).map((item, index) => (
                        <Tr key={index}>
                          {keysResult.map((key) => (
                            <Td key={key}>{item[key]}</Td>
                          ))}
                        </Tr>
                      ))
                      : ""}
                  </Tbody>
                </Table>
                {/* INIZIO Paging Arrow Forward - VECCHIA POSIZIONE ALLA BASE DEL MODALE*/}
                {/* <Flex justifyContent="center" alignItems="center" marginTop={4} marginBottom={4}>
                  {payloadRequestResult.window > 1 ? (
                    <Icon
                      as={MdArrowBack}
                      boxSize={6}
                      onClick={backResult}
                      cursor="pointer"
                      marginRight={4}
                    />
                  ) : (
                    ""
                  )}
                  {payloadRequestResult.window < objectPagination.max_window_num ? (
                    <Icon
                      as={MdArrowForward}
                      boxSize={6}
                      onClick={nextResult}
                      cursor="pointer"
                      marginLeft={4}
                    />
                  ) : (
                    ""
                  )} */}
                {/* FINE Paging Arrow Forward - VECCHIA POSIZIONE ALLA BASE DEL MODALE*/}
                {/* </Flex> */}
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal onClose={closeSaveModal} isOpen={isModalSave} closeOnOverlayClick={false} >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            color={"white"}
            position="sticky"
            top={0}
            zIndex={10}
            
            display="flex" justifyContent="space-between" bgColor={"#0888BE"}><Text>{t('queryTool.saveResult')}</Text> <CloseButton onClick={closeSaveModal} /></ModalHeader>
          <ModalBody>
            <FormControl>
              <FormLabel>
                {t('queryTool.enterResultName')}
              </FormLabel>
              <Input placeholder="Insert text" onChange={(e) => handleChangeResultName(e.target.value)} />
            </FormControl>
          </ModalBody>
          <ModalFooter><Button colorScheme={"green"} onClick={() => salvaRisultato(resultName)}>{t('queryTool.submit')}</Button></ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
export default DragAndDrop;
